export default "__VITE_ASSET__BbnDzvmf__"